// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","216":"forbidden","357":"unauthorized","523":"shop","571":"settings"}[chunkId] || chunkId) + "-legacy." + {"177":"9d055190","178":"a9b7e3b9","216":"654b9d10","357":"e6f5a4f8","523":"c7634050","571":"b997d1bf"}[chunkId] + ".js";
};